// src/hooks/useLearningProgress.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { LearnersLearningpath } from "../../../../../helper/base_url";

const useLearningProgress = (category) => {
  const [learningProgress, setLearningProgress] = useState([]);

  useEffect(() => {
    const fetchProgressData = async () => {
      const token = localStorage.getItem('token');
      if (!token || !category) return;

      try {
        const { data } = await axios.get(
          `${LearnersLearningpath}?category=${encodeURIComponent(category)}`, // Pass category in query params
          {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
          }
        );
        setLearningProgress(data.data.projects || []);
      } catch (err) {
        console.error("Something went wrong.");
      }
    };

    fetchProgressData();
  }, [category]); // Fetch data when category changes

  return learningProgress;
};

export default useLearningProgress;
